import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

function EditResidence() {
  const [residence, setResidence] = useState();
  const [address, setAddress] = useState("");
  const [balance, setBalance] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  let { rid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/residences/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setResidence(response.data.residence);
      setAddress(response.data.residence.address);
      setBalance(response.data.residence.starting_balance);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleAddressChange = (evt) => {
    setAddress(evt.target.value);
  };

  const handleBalanceChange = (evt) => {
    setBalance(evt.target.value);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/residences/${rid}`,
        data: {
          address: address,
          balance: balance,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/residences");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="new-residence">
        <Col>
          <h4>Editar residencia</h4>
        </Col>
        <Col className="new-residence-form">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Dirección de la residencia</Form.Label>
              <Form.Control
                type="text"
                onChange={handleAddressChange}
                value={address}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Balance al momento</Form.Label>
              <Form.Control
                type="number"
                onChange={handleBalanceChange}
                value={balance}
              />
            </Form.Group>
            <Form.Group>
              <Button variant="info" onClick={handleSubmit}>
                Guardar
              </Button>
              <Button variant="danger" onClick={() => navigate("/residences")}>
                Cancelar
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default EditResidence;
